<div class="study-data-view-region">
  <ng-template #expandPanelHeader>
    <div
      class="study-data-view-region__details"
      [ngClass]="{
        'study-data-view-region__details_active': viewRegion.id === activeViewRegionId(),
        'study-data-view-region__details_no-child': !viewRegion?.subregions?.length
      }"
    >
      @if (viewRegion?.subregions?.length) {
        <div class="study-data-view-region__expand-trigger">
          <div class="clickable-icon-wrap_small" (click)="toggleRelatedPanel(expandPanel, $event)">
            <img
              [@turnRightDown]="expandPanel.panelStatus() ? 'down': 'right'"
              class="clickable-icon"
              src="/assets/images/icons/arrow_down.svg"
              alt="toggle panel"
            >
          </div>
        </div>
      }

      <div
        class="study-data-view-region__name study-data-view-region__name_level-{{level}}"
        (click)="focusViewRegion(viewRegion)"
      >{{viewRegion.name}}</div>
    </div>
  </ng-template>

  <app-nested-expansion-panel [headerTemplate]="expandPanelHeader" #expandPanel>
    <div class="study-data-view-region__children">
      @for (subregion of viewRegion.subregions; track subregion.id) {
        <div class="study-data-view-region__child">
          <app-dashboard-study-data-view-region
            [viewRegion]="subregion"
            [activeViewRegionId]="activeViewRegionId"
            [level]="level + 1"
          ></app-dashboard-study-data-view-region>
        </div>
      }
    </div>
  </app-nested-expansion-panel>
</div>
